<div class="form">
    <textarea #message class="form__textarea" name="" id="" cols="30" rows="10" placeholder="Message"></textarea>
    <button class="form__btn" (click)="submit(message.value)" [disabled]="disableSubmit()">Submit</button>
</div>
